/**
 * Shared Clarity print design tokens — sourced from Project BOM.
 * Proposal PDF must reuse these rather than inventing a parallel system.
 */

import type { CSSProperties } from "react";
import { PROPOSAL_ACCENT, PROPOSAL_COPY_FONT, PROPOSAL_TEXT } from "@/lib/proposalTheme";

export const BOM_PRINT_FONT = PROPOSAL_COPY_FONT;
export const BOM_PRINT_TEXT = PROPOSAL_TEXT;
export const BOM_PRINT_ACCENT = PROPOSAL_ACCENT;
export const BOM_PRINT_LABEL = "#6B7280";
export const BOM_PRINT_DESC = "#4B5563";
export const BOM_PRINT_ROW_BORDER = "#E5E7EB";

/** BOM document base typography. */
export const BOM_PRINT_BASE_FONT_SIZE_PX = 11;
export const BOM_PRINT_BASE_LINE_HEIGHT = 1.5;

/** BOM meta block (Customer / Address / Proposal / Date). */
export const BOM_PRINT_META_FONT_SIZE_PX = 10;
export const BOM_PRINT_META_LINE_HEIGHT = 1.7;

/** BOM table. */
export const BOM_PRINT_TABLE_FONT_SIZE_PX = 10;
export const BOM_PRINT_TH_FONT_SIZE_PX = 9;
export const BOM_PRINT_TH_FONT_WEIGHT = 600;
export const BOM_PRINT_TH_LETTER_SPACING = "0.05em";
export const BOM_PRINT_TH_PADDING = "6px 8px";
export const BOM_PRINT_TD_PADDING = "5px 8px";
export const BOM_PRINT_DESC_FONT_SIZE_PX = 9;

/** BOM logo — restrained height. */
export const BOM_PRINT_LOGO_HEIGHT_PX = 28;

/** BOM section title (e.g. Project Summary / option titles). */
export const BOM_PRINT_SECTION_TITLE_FONT_SIZE_PX = 12;
export const BOM_PRINT_H1_FONT_SIZE_PX = 16;

export const bomPrintThStyle: CSSProperties = {
  textAlign: "left",
  padding: BOM_PRINT_TH_PADDING,
  fontWeight: BOM_PRINT_TH_FONT_WEIGHT,
  fontSize: BOM_PRINT_TH_FONT_SIZE_PX,
  textTransform: "uppercase",
  letterSpacing: BOM_PRINT_TH_LETTER_SPACING,
  color: BOM_PRINT_LABEL,
  borderBottom: `1px solid ${BOM_PRINT_TEXT}`,
};

export const bomPrintTdStyle: CSSProperties = {
  padding: BOM_PRINT_TD_PADDING,
  verticalAlign: "top",
  fontSize: BOM_PRINT_TABLE_FONT_SIZE_PX,
  lineHeight: BOM_PRINT_BASE_LINE_HEIGHT,
  fontWeight: 400,
  color: BOM_PRINT_TEXT,
};

export const bomPrintDescTdStyle: CSSProperties = {
  ...bomPrintTdStyle,
  fontSize: BOM_PRINT_DESC_FONT_SIZE_PX,
  color: BOM_PRINT_DESC,
  wordBreak: "break-word",
  whiteSpace: "normal",
  overflow: "visible",
};
